
import React from "react";
import SingleAccordion from "./SingleAccordian";

const Accordions = () => {
  return (
    <div className="accordions max-w-[1280px] mx-auto small:py-10 py-5 md:px-10 px-5 small:mt-10">
      <div className="text-center title">
        <h1 className="text-2xl font-bold lg:text-5xl md:text-4xl text-primary">
          Frequently Asked Questions
        </h1>
      </div>
      <div className="flex flex-col items-center pt-5">
        <SingleAccordion
          title="What services do you offer?"
          description="We compare and offer three types of airport parking services: Meet & Greet Parking – A driver meets you at the terminal and parks your car. Park & Ride Parking – Park your car at a nearby facility and take a shuttle to the terminal. Official Airport Parking – On-site parking provided by the airport."
        />
        <SingleAccordion
          title="Are you the parking provider?"
          description="No, we are a booking comparison agent only. We help you find and book the best deals, but the parking services are provided by independent parking companies."
        />
        <SingleAccordion
          title="What are your customer service hours?"
          description="Our customer service team is available 9:00 AM – 7:00 PM. All amendments, cancellations, and queries must be handled during office hours."
        />
        <SingleAccordion
          title="How can I contact you?"
          description="For booking-related queries and complaints, please email us at info@compareairportparkingdeals.co.uk."
        />
        <SingleAccordion
          title="What should I do if my vehicle is delayed, damaged, or I face service issues?"
          description="Since we are a booking agent, all complaints regarding delays, damage, or service quality must be reported directly to the parking provider. Their contact details are provided in your booking confirmation."
        />
        <SingleAccordion
          title="Can I amend or cancel my booking?"
          description="Yes, amendments and cancellations are allowed but must be processed during office hours only."
        />
        <SingleAccordion
          title="What is your cancellation policy?"
          description="Standard Bookings: Cancellations are allowed up to 72 hours before your departure. With Cancellation Cover: Cancellations are allowed up to 24 hours before departure, but still only during office hours. Out-of-Office Requests: Any cancellation request made outside office hours will not be considered until the next working day."
        />
        <SingleAccordion
          title="How do I know if my booking is confirmed?"
          description="Once your booking is complete, you will receive a confirmation email with all details, including parking provider contact information and instructions."
        />
        <SingleAccordion
          title="What if I need urgent help outside office hours?"
          description="For urgent matters such as flight delays, parking delays, or car-related issues, please contact your parking provider directly. Their contact details will be in your booking confirmation email."
        />
        <SingleAccordion
          title="Do I get a refund if I cancel my booking?"
          description="Refunds depend on whether you cancel within the allowed timeframe: 72 hours before departure (standard) or 24 hours before departure (with cancellation cover). Refund amounts may vary depending on the provider's terms and conditions."
        />
      </div>

      {/* Disclaimer Section */}
      <div className="disclaimer mt-12 mx-auto max-w-4xl">
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 border-l-4 border-primary rounded-lg shadow-lg p-8">
          <div className="flex items-start space-x-4">
            <div className="flex-shrink-0">
              <svg className="h-8 w-8 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div className="flex-1">
              <h2 className="text-2xl font-bold text-primary mb-4 flex items-center">
                <span className="bg-primary text-white px-3 py-1 rounded-full text-sm font-medium mr-3">
                  Important
                </span>
                Disclaimer
              </h2>
              <div className="prose prose-gray max-w-none">
                <p className="text-gray-700 text-base leading-relaxed mb-4">
                  <strong className="text-primary">Airport Parking Deals</strong> acts solely as a booking comparison and reservation agent.
                  All parking services are provided by independent third-party parking operators.
                </p>
                <div className="bg-white rounded-md p-4 border border-gray-200">
                  <p className="text-gray-600 text-sm leading-relaxed mb-0">
                    <span className="inline-block w-2 h-2 bg-red-400 rounded-full mr-2"></span>
                    We are <strong>not responsible</strong> for any delays, damages, service issues, or loss incurred by the parking provider.
                  </p>
                  <p className="text-gray-600 text-sm leading-relaxed mt-3 mb-0">
                    <span className="inline-block w-2 h-2 bg-green-400 rounded-full mr-2"></span>
                    Customers must contact the <strong>parking provider directly</strong> for any operational or service-related complaints.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Accordions;
